/** Default name for the session cookie name / local storage key */
export const SESSION_TOKEN_KEY = 'DS';
/** Default name for the refresh local storage key */
export const REFRESH_TOKEN_KEY = 'DSR';
/* Default name for the id token local storage key */
export const ID_TOKEN_KEY = 'DSI';
/* Default name for the trusted device token (DTD) local storage key */
export const TRUSTED_DEVICE_TOKEN_KEY = 'DTD';
